/**
 * 设置本地存储
 * @param {String} name
 * @param {String} value
 */
export function setStorage(name, value) {
  try {
    window.localStorage.setItem(name, value);
  } catch (e) {
    console.log(e); // eslint-disable-line
  }
}

/**
 * 读取本地存储
 * @param {String} name
 */
export function getStorage(name) {
  try {
    return window.localStorage.getItem(name);
  } catch (e) {
    console.log(e); // eslint-disable-line
  }
  return '';
}

/**
 * 处理数字过万显示
 * @param {number} n
 */
export function handleMillion(n) {
  try {
    let num;
    if (n > 9999) {
      // 大于9999显示x.x万
      num = `${(n / 100 / 100).toFixed(1)}万`;
    } else {
      num = n;
    }
    return num;
  } catch (e) {
    console.log(e); // eslint-disable-line
  }
  return '';
}
